/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { supabase } from '../supabaseClient';

const G   = '#1D9E75';
const GD  = '#0F6E56';
const INK = '#0F1A16';

// Masquage avance des coordonnees — Havenly
function maskCoordinates(text, unlocked) {
  if (unlocked) return text;
  let t = text;
  t = t.replace(/0\uFE0F\u20E3/g,'0').replace(/1\uFE0F\u20E3/g,'1').replace(/2\uFE0F\u20E3/g,'2')
       .replace(/3\uFE0F\u20E3/g,'3').replace(/4\uFE0F\u20E3/g,'4').replace(/5\uFE0F\u20E3/g,'5')
       .replace(/6\uFE0F\u20E3/g,'6').replace(/7\uFE0F\u20E3/g,'7').replace(/8\uFE0F\u20E3/g,'8')
       .replace(/9\uFE0F\u20E3/g,'9');
  t = t.replace(/\+33[\s.\-]?[67][\s.\-]?\d{2}[\s.\-]?\d{2}[\s.\-]?\d{2}[\s.\-]?\d{2}/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/0[67][\s.\-_/]?\d[\d\s.\-_/]{6,14}\d/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/\b\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d[\s.\-_/]?\d\b/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/\b0\s+[67](\s+\d){4,}/g, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/z[e\u00e9]ro[\s\-]?six/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/z[e\u00e9]ro[\s\-]?sept/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/oh[\s\-]?six/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/oh[\s\-]?sept/gi, '\uD83D\uDEAB\u00a0[num\u00e9ro masqu\u00e9]');
  t = t.replace(/(dernier[s]?\s+chiffre[s]?|finit\s+par|termine\s+par)\s*:?\s*\d+/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/les\s+\d+\s+(dernier[s]?|premier[s]?)\s+chiffre[s]?/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/g, '\uD83D\uDEAB\u00a0[email masqu\u00e9]');
  t = t.replace(/\w[\w.\-]*\s*(arobase|\(at\)|\[at\]| at |_at_|\(a\))\s*\w[\w.\-]*\s*(\.|(\bpoint\b)|(\bdot\b))\s*(com|fr|net|org|io)/gi, '\uD83D\uDEAB\u00a0[email masqu\u00e9]');
  t = t.replace(/[\w.\-_]+\s*[\[\(]?\s*(gmail|yahoo|hotmail|outlook|icloud|free|orange|sfr|laposte)\s*[\]\)]?\s*([.\-_]\s*(com|fr|net))?/gi, '\uD83D\uDEAB\u00a0[email masqu\u00e9]');
  t = t.replace(/\b(whatsapp|telegram|signal|wechat|viber|skype|snapchat|instagram|insta|facebook|fb|tiktok|twitter|linkedin|line)\b/gi, '\uD83D\uDEAB\u00a0[contact masqu\u00e9]');
  t = t.replace(/(retrouve[\s\-]?moi|trouve[\s\-]?moi|cherche[\s\-]?moi|ajoute[\s\-]?moi|rejoins[\s\-]?moi)\s*(sur|on|@)?/gi, '\uD83D\uDEAB\u00a0[contact masqu\u00e9]');
  t = t.replace(/(mon\s+pseudo|mon\s+compte|mon\s+profil)\s*(est|=|:)\s*\S+/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/(cherche|google|recherche)\s+mon\s+(nom|pr[e\u00e9]nom|profil|compte)/gi, '\uD83D\uDEAB\u00a0[info masqu\u00e9e]');
  t = t.replace(/https?:\/\/[^\s]+/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  t = t.replace(/\b(www\.|wa\.me\/|bit\.ly\/|tinyurl\.com\/|t\.me\/|linktree\.com\/|calendly\.com\/|linktr\.ee\/)[^\s]*/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  t = t.replace(/\b(wa\.me|bit\.ly|tinyurl|linktree|calendly|linktr\.ee|shorturl)\b/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  t = t.replace(/\b\d+\s+(rue|avenue|av\.|boulevard|bd\.|impasse|all[e\u00e9]e|chemin|route|place|square)\s+[\w\u00C0-\u017E\s]+/gi, '\uD83D\uDEAB\u00a0[adresse masqu\u00e9e]');
  t = t.replace(/\b(google[\s]?maps?|maps\.google|apple[\s]?maps?|waze|citymapper)\b/gi, '\uD83D\uDEAB\u00a0[lien masqu\u00e9]');
  return t;
}

export default function ConciergeConversationDrawer({ request, currentUserId, isManager, onClose }) {
  const [messages, setMessages]       = useState([]);
  const [input, setInput]             = useState('');
  const [sending, setSending]         = useState(false);
  const [loading, setLoading]         = useState(true);
  const [contractSigned, setContractSigned] = useState(!!(request?.contract_signed_at));
  const [signingContract, setSigningContract] = useState(false);
  const [fullRequest, setFullRequest] = useState(request);
  const bottomRef = useRef(null);

  const otherName = isManager
    ? (request?.host_name || 'H\u00f4te')
    : (request?.concierge_name || 'Conciergerie');

  const loadRequest = useCallback(async () => {
    if (!request?.id) return;
    const { data } = await supabase
      .from('concierge_requests')
      .select('*')
      .eq('id', request.id)
      .single();
    if (data) {
      setFullRequest(data);
      setContractSigned(!!(data.contract_signed_at));
    }
  }, [request?.id]);

  const loadMessages = useCallback(async () => {
    if (!request?.id) return;
    const { data } = await supabase
      .from('messages')
      .select('*')
      .eq('concierge_request_id', request.id)
      .order('created_at', { ascending: true });
    setMessages(data || []);
    setLoading(false);
    await supabase
      .from('messages')
      .update({ read_at: new Date().toISOString() })
      .eq('concierge_request_id', request.id)
      .neq('sender_id', currentUserId)
      .is('read_at', null);
  }, [request?.id, currentUserId]);

  useEffect(() => {
    loadRequest();
    loadMessages();
  }, [loadRequest, loadMessages]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    if (!request?.id) return;
    const channel = supabase
      .channel('concierge-msg-' + request.id)
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'messages',
        filter: 'concierge_request_id=eq.' + request.id,
      }, (payload) => {
        setMessages(prev => {
          if (prev.find(m => m.id === payload.new.id)) return prev;
          return [...prev, payload.new];
        });
        if (payload.new.sender_id !== currentUserId) {
          supabase.from('messages').update({ read_at: new Date().toISOString() }).eq('id', payload.new.id);
        }
      })
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, [request?.id, currentUserId]);

  const sendMessage = async () => {
    if (!input.trim() || sending) return;
    setSending(true);
    const content = input.trim();
    setInput('');
    const tempMsg = {
      id: 'temp-' + Date.now(),
      concierge_request_id: request.id,
      sender_id: currentUserId,
      content,
      created_at: new Date().toISOString(),
      read_at: null,
    };
    setMessages(prev => [...prev, tempMsg]);
    const { data: inserted } = await supabase.from('messages').insert({
      concierge_request_id: request.id,
      sender_id: currentUserId,
      content,
    }).select().single();
    if (inserted) {
      setMessages(prev => prev.map(m => m.id === tempMsg.id ? inserted : m));
    }
    setSending(false);
  };

  const signContract = async () => {
    if (!request?.id) return;
    const confirmed = window.confirm(
      'En confirmant, vous certifiez sur l\'honneur qu\'un contrat de gestion a bien \u00e9t\u00e9 sign\u00e9 entre les deux parties.\n\nUn email sera envoy\u00e9 \u00e0 l\'h\u00f4te pour confirmer la mise en relation.\n\nContinuer ?'
    );
    if (!confirmed) return;
    setSigningContract(true);
    const now = new Date().toISOString();
    await supabase
      .from('concierge_requests')
      .update({ contract_signed_at: now, status: 'signed' })
      .eq('id', request.id);
    if (fullRequest?.host_email) {
      await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'concierge_contract_signed',
          to: fullRequest.host_email,
          data: { hostName: fullRequest.host_name, conciergeName: request.concierge_name },
        }),
      }).catch(() => {});
    }
    setContractSigned(true);
    setFullRequest(p => ({ ...p, contract_signed_at: now }));
    setSigningContract(false);
  };

  const formatTime = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    if (diffDays === 1) return 'Hier ' + date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:9998, backdropFilter:'blur(2px)' }}/>
      <div style={{ position:'fixed', right:0, top:0, bottom:0, width:'100%', maxWidth:420, background:'#fff', zIndex:9999, display:'flex', flexDirection:'column', boxShadow:'-8px 0 40px rgba(0,0,0,0.15)', animation:'slideIn 0.25s ease' }}>
        <style>{`@keyframes slideIn { from { transform:translateX(100%); opacity:0; } to { transform:translateX(0); opacity:1; } }`}</style>

        {/* Header */}
        <div style={{ padding:'16px 20px', borderBottom:'1px solid #EAECEF', background:'linear-gradient(135deg,#E8F5F0 0%,#fff 100%)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:38, height:38, borderRadius:'50%', background:'#E8F5F0', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, fontWeight:700, color:GD, flexShrink:0 }}>
                {otherName.charAt(0).toUpperCase()}
              </div>
              <div>
                <div style={{ fontSize:14, fontWeight:600, color:INK }}>{otherName}</div>
                <div style={{ fontSize:11, color:'#6B7280' }}>{isManager ? 'H\u00f4te' : 'Conciergerie Havenly'}</div>
              </div>
            </div>
            <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'#6B7280', fontSize:22, padding:'0 0 0 8px', lineHeight:1 }}>\u00d7</button>
          </div>

          {contractSigned ? (
            <div style={{ marginTop:10, display:'inline-flex', alignItems:'center', gap:5, background:'#E8F5F0', border:'1px solid #A7E3CD', borderRadius:20, padding:'4px 12px' }}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="1.5,6 5,9.5 10.5,2.5" stroke={GD} strokeWidth="2" strokeLinecap="round"/></svg>
              <span style={{ fontSize:11, color:GD, fontWeight:600 }}>Contrat sign\u00e9 \u2014 coordonn\u00e9es d\u00e9bloqu\u00e9es</span>
            </div>
          ) : (
            <div style={{ marginTop:10, display:'inline-flex', alignItems:'center', gap:5, background:'#FDF0E6', border:'1px solid #E8A87C', borderRadius:20, padding:'3px 10px' }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
              <span style={{ fontSize:11, color:'#C4784A', fontWeight:500 }}>Coordonn\u00e9es verrouill\u00e9es jusqu\u00e2\u0080\u0099\u00e0 la signature du contrat</span>
            </div>
          )}

          {/* Coordonnees debloquees apres contrat */}
          {contractSigned && (
            <div style={{ marginTop:12, padding:'12px 14px', background:'#F0FDF9', border:'1px solid #A7E3CD', borderRadius:10 }}>
              <div style={{ fontSize:11, fontWeight:600, color:GD, marginBottom:8 }}>
                {isManager ? "Coordonn\u00e9es de l'h\u00f4te" : 'Coordonn\u00e9es de la conciergerie'}
              </div>
              {isManager ? (
                <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                  {fullRequest?.host_email && (
                    <a href={'mailto:' + fullRequest.host_email} style={{ fontSize:12, color:INK, textDecoration:'none', display:'flex', alignItems:'center', gap:6 }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={GD} strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                      {fullRequest.host_email}
                    </a>
                  )}
                  {fullRequest?.host_phone && (
                    <a href={'tel:' + fullRequest.host_phone} style={{ fontSize:12, color:INK, textDecoration:'none', display:'flex', alignItems:'center', gap:6 }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={GD} strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.4 1.14 2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.09a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15z"/></svg>
                      {fullRequest.host_phone}
                    </a>
                  )}
                  {!fullRequest?.host_email && !fullRequest?.host_phone && (
                    <div style={{ fontSize:12, color:'#9CA3AF' }}>Aucune coordonn\u00e9e renseign\u00e9e par l'h\u00f4te.</div>
                  )}
                </div>
              ) : (
                <div style={{ fontSize:12, color:'#6B7280' }}>Les coordonn\u00e9es de la conciergerie sont disponibles dans la messagerie.</div>
              )}
            </div>
          )}

          {/* Bouton signer contrat — conciergerie uniquement */}
          {isManager && !contractSigned && (
            <button onClick={signContract} disabled={signingContract}
              style={{ marginTop:12, width:'100%', padding:'9px 16px', background: signingContract ? '#9CA3AF' : GD, color:'#fff', border:'none', borderRadius:10, fontSize:12, fontWeight:600, cursor: signingContract ? 'default' : 'pointer', fontFamily:'var(--sans)', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
              {signingContract ? 'Enregistrement...' : 'Marquer le contrat comme sign\u00e9'}
            </button>
          )}

          {!contractSigned && (
            <div style={{ marginTop:8, fontSize:11, color:'#9CA3AF', display:'flex', alignItems:'center', gap:4 }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              Les num\u00e9ros, emails et apps de contact sont automatiquement masqu\u00e9s.
            </div>
          )}
        </div>

        {/* Messages */}
        <div style={{ flex:1, overflowY:'auto', padding:'16px 20px', display:'flex', flexDirection:'column', gap:12, background:'#FAFAF8' }}>
          {loading ? (
            <div style={{ textAlign:'center', fontSize:13, color:'#9CA3AF', marginTop:40 }}>Chargement...</div>
          ) : messages.length === 0 ? (
            <div style={{ textAlign:'center', padding:'40px 20px' }}>
              <div style={{ fontSize:32, marginBottom:12 }}>💬</div>
              <div style={{ fontSize:14, fontWeight:500, color:INK, marginBottom:6 }}>D\u00e9marrez la conversation</div>
              <div style={{ fontSize:13, color:'#6B7280', lineHeight:1.6 }}>
                {isManager
                  ? 'Posez vos questions \u00e0 cet h\u00f4te avant de signer un contrat.'
                  : 'La conciergerie va vous r\u00e9pondre pour discuter de votre projet.'}
              </div>
            </div>
          ) : (
            <>
              <div style={{ textAlign:'center', margin:'8px 0' }}>
                <span style={{ fontSize:11, color:'#9CA3AF', background:'#EAECEF', padding:'3px 10px', borderRadius:20 }}>
                  Conversation ouverte suite \u00e0 votre demande
                </span>
              </div>
              {messages.map((msg, i) => {
                const isMe = msg.sender_id === currentUserId;
                const showTime = i === 0 || (new Date(msg.created_at) - new Date(messages[i-1].created_at)) > 5 * 60 * 1000;
                const displayContent = maskCoordinates(msg.content, contractSigned);
                const wasMasked = displayContent !== msg.content;
                return (
                  <div key={msg.id}>
                    {showTime && (
                      <div style={{ textAlign:'center', fontSize:10, color:'#9CA3AF', margin:'4px 0' }}>
                        {formatTime(msg.created_at)}
                      </div>
                    )}
                    <div style={{ display:'flex', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
                      <div style={{
                        maxWidth:'78%', padding:'9px 13px',
                        borderRadius: isMe ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                        background: isMe ? G : '#fff',
                        color: isMe ? '#fff' : INK,
                        fontSize:13, lineHeight:1.55,
                        border: isMe ? 'none' : '1px solid #EAECEF',
                        boxShadow: isMe ? 'none' : '0 1px 4px rgba(0,0,0,0.06)',
                        opacity: msg.id?.startsWith('temp-') ? 0.6 : 1,
                      }}>
                        {displayContent}
                        {wasMasked && (
                          <div style={{ fontSize:10, marginTop:4, color: isMe ? 'rgba(255,255,255,0.7)' : '#9CA3AF', fontStyle:'italic' }}>
                            Coordonn\u00e9es masqu\u00e9es \u2014 signez le contrat pour les voir
                          </div>
                        )}
                        {isMe && !msg.id?.startsWith('temp-') && (
                          <div style={{ fontSize:10, opacity:0.7, marginTop:3, textAlign:'right' }}>
                            {msg.read_at ? '\u2713\u2713' : '\u2713'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {contractSigned && (
                <div style={{ textAlign:'center', margin:'8px 0' }}>
                  <span style={{ fontSize:11, color:GD, background:'#E8F5F0', padding:'3px 10px', borderRadius:20, border:'1px solid #A7E3CD' }}>
                    Contrat sign\u00e9 \u2014 coordonn\u00e9es d\u00e9bloqu\u00e9es
                  </span>
                </div>
              )}
              <div ref={bottomRef}/>
            </>
          )}
        </div>

        {/* Input */}
        <div style={{ padding:'12px 16px', borderTop:'1px solid #EAECEF', background:'#fff' }}>
          <div style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
            <textarea
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
              placeholder="Votre message..."
              rows={1}
              style={{ flex:1, padding:'10px 14px', border:'1px solid #EAECEF', borderRadius:20, fontSize:13, fontFamily:'var(--sans)', outline:'none', resize:'none', lineHeight:1.5, maxHeight:100, overflowY:'auto', background:'#F9FAFB' }}
              onInput={e => { e.target.style.height = 'auto'; e.target.style.height = Math.min(e.target.scrollHeight, 100) + 'px'; }}
            />
            <button onClick={sendMessage} disabled={!input.trim() || sending}
              style={{ width:38, height:38, borderRadius:'50%', background: input.trim() ? G : '#EAECEF', border:'none', cursor: input.trim() ? 'pointer' : 'default', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'background 0.2s' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            </button>
          </div>
          <div style={{ fontSize:11, color:'#9CA3AF', marginTop:6, textAlign:'center' }}>
            Entr\u00e9e pour envoyer \u00b7 Shift+Entr\u00e9e pour sauter une ligne
          </div>
        </div>
      </div>
    </>
  );
}
